import { useState } from 'react';
import { newDocument } from '../../state/actions';
import { useAppStore } from '../../state/store';
import { Modal, NumberInput, Select } from '../components/controls';

const PRESETS = [
  { label: 'Custom', width: 1200, height: 800 },
  { label: 'Full HD 1920 × 1080', width: 1920, height: 1080 },
  { label: '4K 3840 × 2160', width: 3840, height: 2160 },
  { label: 'Instagram 1080 × 1080', width: 1080, height: 1080 },
  { label: 'Story 1080 × 1920', width: 1080, height: 1920 },
  { label: 'A4 300 dpi 2480 × 3508', width: 2480, height: 3508 },
];

type Background = 'white' | 'transparent' | 'color';

export function NewDocumentDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [name, setName] = useState('Untitled');
  const [width, setWidth] = useState(1200);
  const [height, setHeight] = useState(800);
  const [background, setBackground] = useState<Background>('white');
  const backgroundColor = useAppStore((state) => state.background);

  const create = () => {
    newDocument({ name: name.trim() || 'Untitled', width, height, background, color: backgroundColor });
    onClose();
  };

  return (
    <Modal
      open={open}
      title="New Document"
      onClose={onClose}
      footer={
        <>
          <button type="button" className="button" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="button button--primary" onClick={create}>
            Create
          </button>
        </>
      }
    >
      <div className="field field--stack">
        <span className="field__label">Name</span>
        <input
          className="text-input"
          value={name}
          autoFocus
          onChange={(event) => setName(event.target.value)}
        />
      </div>

      <div className="field field--stack">
        <span className="field__label">Preset</span>
        <Select
          value={`${width}x${height}`}
          options={PRESETS.map((preset) => ({
            value: `${preset.width}x${preset.height}`,
            label: preset.label,
          }))}
          onChange={(value) => {
            const [w, h] = value.split('x').map(Number);
            setWidth(w);
            setHeight(h);
          }}
        />
      </div>

      <div className="field">
        <span className="field__label" style={{ width: 66 }}>
          Width
        </span>
        <NumberInput value={width} min={1} max={16384} onChange={setWidth} width={90} />
        <span className="field__label">px</span>
        <span className="field__label" style={{ width: 56, textAlign: 'right' }}>
          Height
        </span>
        <NumberInput value={height} min={1} max={16384} onChange={setHeight} width={90} />
        <span className="field__label">px</span>
      </div>

      <div className="field field--stack">
        <span className="field__label">Background Contents</span>
        <Select<Background>
          value={background}
          options={[
            { value: 'white', label: 'White' },
            { value: 'transparent', label: 'Transparent' },
            { value: 'color', label: 'Background Color' },
          ]}
          onChange={setBackground}
        />
      </div>

      <p className="dialog__note">
        Size: {(width * height * 4 * 1e-6).toFixed(1)} MB of GPU memory per layer.
      </p>
    </Modal>
  );
}
